module.exports = __webpack_public_path__ + "8f5ab45a76e369bdc0e1c3a75b2f84b8.svg";